import React, { useState } from 'react';
import {
  CheckCircle2,
  XCircle,
  RefreshCw,
  Clock,
  List,
  TrendingUp,
  Package,
  ChevronDown,
  ChevronUp
} from 'lucide-react';

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// ReviewGate
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const ReviewGate = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');

  const handleReject = () => {
    if (rejectReason.trim()) {
      onReject(rejectReason);
      setShowRejectModal(false);
      setRejectReason('');
    }
  };

  if (execution.status === 'approved') {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-green-700">
          <CheckCircle2 className="w-5 h-5" />
          <span className="font-medium">Execution approvata</span>
        </div>
      </div>
    );
  }

  if (execution.status === 'rejected') {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-red-700">
          <XCircle className="w-5 h-5" />
          <span className="font-medium">Execution rigettata</span>
        </div>
        {execution.rejectionReason && (
          <p className="text-sm text-red-600 mt-2">{execution.rejectionReason}</p>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h3 className="font-medium text-gray-800 mb-3">Revisiona Output</h3>
        <div className="flex gap-3">
          <button onClick={() => onApprove()} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50">
            <CheckCircle2 className="w-4 h-4" /> Approva
          </button>
          <button onClick={onRegenerate} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50">
            <RefreshCw className="w-4 h-4" /> Rigenera
          </button>
          <button onClick={() => setShowRejectModal(true)} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50">
            <XCircle className="w-4 h-4" /> Rigetta
          </button>
        </div>
      </div>

      {showRejectModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <h3 className="text-lg font-semibold mb-4">Motivo del Rigetto</h3>
            <textarea value={rejectReason} onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Spiega perchÃ© rigetti questa execution..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
              rows={4} />
            <div className="flex gap-3 mt-4">
              <button onClick={() => setShowRejectModal(false)}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                Annulla
              </button>
              <button onClick={handleReject} disabled={!rejectReason.trim()}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50">
                Conferma Rigetto
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// SequenceList
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const SequenceList = ({ icon: Icon, title, items = [], colorClass, bgClass }) => {
  if (!items.length) return null;
  return (
    <div className={`rounded-lg border overflow-hidden ${bgClass}`}>
      <div className="flex items-center gap-2 p-3 border-b border-gray-100 bg-white">
        <Icon className={`w-4 h-4 ${colorClass}`} />
        <span className={`text-xs font-semibold uppercase tracking-wide ${colorClass}`}>{title}</span>
        <span className="ml-auto text-xs text-gray-400">{items.length} entries</span>
      </div>
      <ol className="divide-y divide-gray-100">
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-3 p-3">
            <span className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full text-xs font-bold ${colorClass} bg-white border border-current`}>
              {i + 1}
            </span>
            <p className="text-sm text-gray-700 leading-relaxed">{typeof item === "string" ? item : JSON.stringify(item)}</p>
          </li>
        ))}
      </ol>
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// AlternativeSequence
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const AlternativeSequence = ({ index, sequence = [], curve = [], proof = [] }) => {
  const [expanded, setExpanded] = useState(false);
  if (!sequence.length) return null;
  return (
    <div className="rounded-lg border border-gray-200 overflow-hidden">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 transition-colors"
      >
        <span className="text-xs font-medium text-gray-600">
          Alternative {index + 1} â€” {sequence.length} observations
        </span>
        {expanded ? <ChevronUp className="w-4 h-4 text-gray-400" /> : <ChevronDown className="w-4 h-4 text-gray-400" />}
      </button>
      {expanded && (
        <div className="p-3 space-y-3">
          {sequence.length > 0 && (
            <div>
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2">Observation Sequence</p>
              <ol className="space-y-1">
                {sequence.map((obs, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full bg-amber-100 text-amber-700 text-xs font-bold">{i + 1}</span>
                    <p className="text-sm text-gray-700">{obs}</p>
                  </li>
                ))}
              </ol>
            </div>
          )}
          {curve.length > 0 && (
            <div>
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2">Prediction Error Curve</p>
              <ol className="space-y-1">
                {curve.map((entry, i) => (
                  <li key={i} className="text-sm text-gray-600 flex items-start gap-2">
                    <span className="text-xs text-gray-400 w-4 flex-shrink-0">{i + 1}.</span>
                    {entry}
                  </li>
                ))}
              </ol>
            </div>
          )}
          {proof.length > 0 && (
            <div>
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2">Proof Distribution</p>
              <ol className="space-y-1">
                {proof.map((entry, i) => (
                  <li key={i} className="text-sm text-gray-600 flex items-start gap-2">
                    <span className="text-xs text-gray-400 w-4 flex-shrink-0">{i + 1}.</span>
                    {entry}
                  </li>
                ))}
              </ol>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// EmptyState
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const EmptyState = () => (
  <div className="flex items-center justify-center h-full">
    <div className="text-center text-gray-500">
      <Clock className="w-12 h-12 mx-auto mb-4 text-gray-300" />
      <p className="text-lg font-medium mb-2">In attesa di esecuzione</p>
      <p className="text-sm">Clicca "Esegui Contract" per avviare l'Observation Sequencing</p>
    </div>
  </div>
);

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Contract07View
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const Contract07View = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  if (!execution) return <EmptyState />;

  const output = execution.output || execution.outputData || {};
  const altSequences = output.alternative_observation_sequences || [];
  const altCurves = output.alternative_prediction_error_curves || [];
  const altProofs = output.alternative_proof_distributions || [];

  return (
    <div className="h-full overflow-y-auto p-6">
      <div className="max-w-4xl mx-auto space-y-6">

        {/* Header */}
        <div>
          <div className="flex items-center gap-3 mb-1">
            <List className="w-6 h-6 text-amber-600" />
            <h2 className="text-xl font-bold text-gray-800">Observation Sequencing</h2>
            <span className="px-2 py-0.5 text-xs bg-amber-100 text-amber-700 rounded-full font-medium">C07</span>
          </div>
          <p className="text-sm text-gray-500">Sequenza osservazionale, prediction error curve e proof distribution</p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-3">
          {[
            { label: 'Observations', count: (output.observation_sequence || []).length, color: 'text-amber-700 bg-amber-50' },
            { label: 'Prediction Errors', count: (output.prediction_error_curve || []).length, color: 'text-blue-700 bg-blue-50' },
            { label: 'Proof Elements', count: (output.proof_distribution || []).length, color: 'text-green-700 bg-green-50' }
          ].map(({ label, count, color }) => (
            <div key={label} className="bg-white border border-gray-200 rounded-lg p-3 text-center">
              <div className={`text-2xl font-bold ${color.split(' ')[0]}`}>{count}</div>
              <div className="text-xs text-gray-500 mt-1">{label}</div>
            </div>
          ))}
        </div>

        {/* Primary Output */}
        <div className="space-y-4">
          <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide">Output Primario</h3>

          <SequenceList
            icon={List}
            title="Observation Sequence"
            items={output.observation_sequence}
            colorClass="text-amber-700"
            bgClass="bg-amber-50 border-amber-200"
          />

          <SequenceList
            icon={TrendingUp}
            title="Prediction Error Curve"
            items={output.prediction_error_curve}
            colorClass="text-blue-700"
            bgClass="bg-blue-50 border-blue-200"
          />

          <SequenceList
            icon={Package}
            title="Proof Distribution"
            items={output.proof_distribution}
            colorClass="text-green-700"
            bgClass="bg-green-50 border-green-200"
          />
        </div>

        {/* Alternatives */}
        {altSequences.length > 0 && (
          <div className="space-y-2">
            <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
              Sequenze Alternative ({altSequences.length})
            </h3>
            {altSequences.map((seq, i) => (
              <AlternativeSequence
                key={i}
                index={i}
                sequence={Array.isArray(seq) ? seq : [seq]}
                curve={Array.isArray(altCurves[i]) ? altCurves[i] : (altCurves[i] ? [altCurves[i]] : [])}
                proof={Array.isArray(altProofs[i]) ? altProofs[i] : (altProofs[i] ? [altProofs[i]] : [])}
              />
            ))}
          </div>
        )}

        {/* Review Gate */}
        <ReviewGate
          execution={execution}
          onApprove={onApprove}
          onReject={onReject}
          onRegenerate={onRegenerate}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default Contract07View;

